/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: [],
  searching: false,
};

const reducers = {
  setQueues: (state, action) => {
    state.list = action.payload;
  },
  startSearching: (state) => {
    state.searching = true;
  },
  stopSearching: (state) => {
    state.searching = false;
  },
};

export const queues = createSlice({
  name: 'queues',
  initialState,
  reducers,
});
